import {
  Action,
  ActionCreator,
  ActionReducer,
  ActionType,
  createReducer,
  on,
  ReducerTypes,
} from '@ngrx/store';
import { setActivePath, showLoading, hideLoading } from './app.actions';
import { initialAppState } from './app.state';

export const appReducer = createRehydrateReducer(
  'PVT_App_Page_State',
  initialAppState,
  on(setActivePath, (state, { activePath }) => ({
    ...state,
    activePath,
  })),
  on(showLoading, (state) => ({ ...state, loading: true })),
  on(hideLoading, (state) => ({ ...state, loading: false }))
);

// Implementation Reference: https://lordmairtis.wixsite.com/zdengineering/post/the-easiest-way-to-keep-ngrx-state-after-refresh-rehydrate-it-from-localstorage
export function createRehydrateReducer<S, A extends Action = Action>(
  key: string,
  initialState: S,
  ...ons: ReducerTypes<S, ActionCreator[]>[]
): ActionReducer<S, A> {
  const item = localStorage.getItem(key);
  const newInitialState = (item && JSON.parse(item)) ?? initialState;

  const newOns: ReducerTypes<S, ActionCreator[]>[] = [];
  ons.forEach((oldOn: ReducerTypes<S, ActionCreator[]>) => {
    const newReducer: ActionReducer<S, A> = (
      state: S | undefined,
      action: ActionType<ActionCreator[][number]>
    ) => {
      const newState = oldOn.reducer(state, action);
      localStorage.setItem(key, JSON.stringify(newState));
      return newState;
    };
    newOns.push({ ...oldOn, reducer: newReducer });
  });
  return createReducer(newInitialState, ...newOns);
}
